import { Checkbox, Hint, Spacer } from '@lokalise/louis';

import Bracket from '@app/components/Bracket';

import { ProjectType } from '../../../../types/project';
import type { FileFormat } from '../../types';
import ExportAccordion from '../ExportAccordion';
import FileFormatInput from '../FileFormatInput';

type Value = {
    fileFormat: FileFormat;
    switchIncludeAll: boolean;
};

interface FileFormatToDownloadProps {
    value: Value;
    projectType: ProjectType;
    projectId: string;
    onChange: (value: Value) => void;
}

const FileFormatToDownload = ({ value, projectType, projectId, onChange }: FileFormatToDownloadProps) => (
    <ExportAccordion heading="File format" name="file-format" projectId={projectId} initiallyExpanded>
        <section aria-label="File format">
            <Spacer bottom={2} top={3}>
                <FileFormatInput
                    value={value.fileFormat}
                    onChange={(val) => {
                        onChange({ ...value, fileFormat: val });
                    }}
                />
            </Spacer>
            {projectType === ProjectType.localizationFiles && (
                <Bracket>
                    <Checkbox
                        checked={value.switchIncludeAll}
                        onChange={() => onChange({ ...value, switchIncludeAll: !value.switchIncludeAll })}
                    >
                        Include all platform keys{' '}
                        <Hint placement="top">Export keys of all project platforms in specified file format.</Hint>
                    </Checkbox>
                </Bracket>
            )}
        </section>
    </ExportAccordion>
);

export default FileFormatToDownload;
